export default {
  results: {},
  editQuery: {},
};
